import React from 'react';
import { Box } from '@mui/material';
import RoomIcon from './RoomIcon';

const rooms = [
  { id: 1, room_number: '101', current_status: 'vacant_clean' },
  { id: 2, room_number: '102', current_status: 'vacant_dirty' },
  { id: 3, room_number: '103', current_status: 'occupied' },
  { id: 4, room_number: '104', current_status: 'maintenance' },
  { id: 5, room_number: '105', current_status: 'vacant_clean' },
  { id: 6, room_number: '106', current_status: 'vacant_dirty' },
  { id: 7, room_number: '107', current_status: 'occupied' },
  { id: 8, room_number: '108', current_status: 'maintenance' },
  { id: 9, room_number: '109', current_status: 'vacant_clean' },
  { id: 10, room_number: '110', current_status: 'occupied' },
  { id: 11, room_number: '111', current_status: 'vacant_clean' },
];

const RoomGrid = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around', // spread evenly
        alignItems: 'center',
        width: '100%',
        maxWidth: 1200, // limit max width for nicer centering
        mx: 'auto', // center horizontally
        py: 2,
      }}
    >
      {rooms.slice(0, 10).map(room => (
        <Box key={room.id} sx={{ width: 20, height:20 }}>
          <RoomIcon
            room={room}
            // You may want to pass size prop here if you update RoomIcon
          />
        </Box>
      ))}
    </Box>
  );
};

export default RoomGrid;
